import { render, staticRenderFns } from "./ApprovalProcessEditor.vue?vue&type=template&id=19ed3f86"
import script from "./ApprovalProcessEditor.vue?vue&type=script&lang=js"
export * from "./ApprovalProcessEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports